/** Matches API `product::ProductSource` (JSON field `source`). */
export enum ProductSource {
  Backoffice = 'Backoffice',
  Webshop = 'Webshop',
  MyPages = 'MyPages',
  App = 'App',
  External = 'External',
  Register = 'Register'
}
